"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcClient = void 0;
var client_1 = require("./client");
var class_validator_1 = require("class-validator");
var bt_rpc_base_1 = require("bt-rpc-base");
var ImprobableRpcWeb = (function () {
    function ImprobableRpcWeb(httpHost, appPath, headers, withCredentials, exceptionHandler, timeoutMill, debug) {
        if (debug === void 0) { debug = 0; }
        this.pathPrefix_ = httpHost + appPath;
        this.headers_ = headers;
        this.exceptionHandler_ = exceptionHandler;
        this.timeoutMill_ = timeoutMill;
        this.withCredentials_ = withCredentials;
        this.debug_ = debug ? true : false;
    }
    ImprobableRpcWeb.prototype.async = function (method, param, cfg) {
        var _this = this;
        var input = new bt_rpc_base_1.InputProto();
        var eh = (cfg === null || cfg === void 0 ? void 0 : cfg.exceptionHandler) || this.exceptionHandler_;
        if (param !== undefined && param !== null) {
            var errors = (0, class_validator_1.validateSync)(param, { validationError: { target: false } });
            if (errors.length > 0) {
                return Promise.reject(new bt_rpc_base_1.RpcError(bt_rpc_base_1.RpcError.CLIENT_INVALID_ARGUMENT, JSON.stringify(errors))).catch(eh);
            }
            input.setUtf8(JSON.stringify(param));
        }
        var prom = new Promise(function (resolve, reject) {
            var grpcClient = new client_1.GrpcClient(_this.pathPrefix_ + method, function (hd) {
                var _a = (0, bt_rpc_base_1.parseStatus)(hd), status = _a[0], msg = _a[1];
                if (status) {
                    reject(new bt_rpc_base_1.RpcError(status, msg));
                }
            }, function (msgBytes) {
                var outp = bt_rpc_base_1.OutputProto.deserializeBinary(msgBytes);
                resolve((0, bt_rpc_base_1.toResult)(outp));
            }, function (status, statusMessage, resMeta) {
                if (status) {
                    reject(new bt_rpc_base_1.RpcError(status, statusMessage));
                }
            }, _this.withCredentials_, RpcClient.debug);
            grpcClient.send(input, (cfg === null || cfg === void 0 ? void 0 : cfg.headers) ? (0, bt_rpc_base_1.mergeHeader)(cfg === null || cfg === void 0 ? void 0 : cfg.headers, _this.headers_) : _this.headers_);
            if (_this.timeoutMill_) {
                setTimeout(function () { return grpcClient.close(); }, _this.timeoutMill_);
            }
        });
        if (eh) {
            prom.catch(eh);
        }
        return prom;
    };
    return ImprobableRpcWeb;
}());
var RpcClient = (function () {
    function RpcClient() {
    }
    RpcClient.create = function (c) {
        var withCredentials = c.withCredentials || false;
        var _a = (0, bt_rpc_base_1.preproc)(c), httpHost = _a[0], appPath = _a[1], headers = _a[2];
        return new ImprobableRpcWeb(httpHost, appPath, headers, withCredentials, c.exceptionHandler, c.timeoutMill);
    };
    RpcClient.debug = 0;
    return RpcClient;
}());
exports.RpcClient = RpcClient;
